
import React, { useState, useEffect } from "react";
import { Form, Button, Table } from "antd";
import { FormItemTypeEnum, ISelectOption } from "../../../../components2/YhFormBox/Types"
import { YhFormItemsBox } from "../../../../components2/YhFormBox"
import { useEntityModel } from "../entityModel"
import useMdmModel from "../../../../model/mdmModel"
import { useNavModel } from "../../../../model/navModel";
import { DetailType } from "../../../../types/FmsEnums";
import { IEntitySearch, IEntityParams, IEntityDetail, IEntityInsert, IEntityUpdata, IEntityDisable } from "../entityTypes"
import { setTitle, filterArrId, Optios, loadDictParam } from "../../../../utils/utils"
const EntityDetail = () => {
    const [form] = Form.useForm();
    const { mdmCatalog, mdmBranch, mdmSourceApp, mdmOrgan, dict } = useMdmModel();
    const { selectedNavId, addNav, closeNav, getSelectedNavState, replaceNav, findNav } = useNavModel()
    const { addParam, selectedRow, bankList, entityList, setBankList, setEntityList, setAddParam, setSelectedRow, setSelectedRowKeys, updataAddParam, updataEditParam, insertDetail, updataDetail } = useEntityModel()
    const [modes, setModes] = useState<any>(getSelectedNavState("state"))
    const { id, pageParams } = modes
    const { mode, id: ids } = pageParams

    useEffect(() => {
        if (mode == DetailType.add) {
            form.setFieldsValue(addParam)
        } else if (mode == DetailType.edit || mode == DetailType.look) {
            form.setFieldsValue({ ...selectedRow[0], application: (typeof selectedRow[0].application === "string" && selectedRow[0].application) ? selectedRow[0].application.split(",") : selectedRow[0].application })
        }
    }, [addParam, selectedRow[0]])

    const onFinish = (values: IEntityInsert | IEntityUpdata) => {
        let applicationName: string[] = [];
        if (typeof values.application === "object") {
            values.application.forEach(appCode => {
                let findApp = mdmSourceApp.find(item => item.value === appCode);
                findApp && applicationName.push(findApp.label);
            })
        }
        let data = {
            ...values,
            application: typeof values.application === "object" ? values.application.join() : null,
            applicationName: applicationName.join()
        };
        if (mode == DetailType.add) {
            insertDetail(data as IEntityInsert).then(res => res && close())
        } else if (mode == DetailType.edit) {
            updataDetail(data as IEntityDetail).then(res => res && close())
        }
    }
    useEffect(() => {
        setBankList(loadDictParam('account-bank', dict, "name"))
        // setEntityList(loadDictParam('entity', dict, "name"))
    }, [])

    // //应用类型
    // const appChang = (value: string, option: ISelectOption[]) => {
    //     console.log(value, option)
    //     option && form.setFieldsValue({ applicationName: option.map(item => item.label) });
    // }

    // useEffect(() => {
    //     return () => {
    //         const findInsert = findNav("2-11-1")
    //         const findEdit = findNav("2-11-2")
    //         !!!findInsert && setAddParam({});
    //         !!!findEdit && setSelectedRowKeys([]) && setSelectedRow([]);
    //     }
    // }, [selectedNavId])
    const close = () => {
        replaceNav(selectedNavId, "2-11")
    }
    const items = [
        {
            type: FormItemTypeEnum.Select,
            span: 8,
            fieldLabel: "分支编码",
            labelCol: { span: 6 },
            fieldName: "branch",
            options: mdmBranch
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "数据版本号",
            labelCol: { span: 6 },
            fieldName: "ver",
            disable: true,
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "经营实体编码",
            labelCol: { span: 6 },
            fieldName: "code",
            disable: mode == DetailType.edit
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "经营实体名称",
            labelCol: { span: 6 },
            fieldName: "name",
            rules: [{ required: true, message: '该项为必填项' }],
            // options: entityList
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "法人",
            labelCol: { span: 6 },
            fieldName: "corporation",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "联系电话",
            labelCol: { span: 6 },
            fieldName: "phone",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "联系地址",
            labelCol: { span: 6 },
            fieldName: "address",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "银行账户",
            labelCol: { span: 6 },
            fieldName: "bankAcct",
        },
        {
            type: FormItemTypeEnum.Select,
            span: 8,
            fieldLabel: "开户银行",
            labelCol: { span: 6 },
            fieldName: "bank",
            options: bankList
        },
        
        {
            type: FormItemTypeEnum.Select,
            span: 8,
            labelCol: { span: 6 },
            fieldLabel: "应用系统",
            fieldName: "application",
            mode: "multiple",
            options: mdmSourceApp,
            // onSelectChange: appChang,
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "营业执照编号",
            labelCol: { span: 6 },
            fieldName: "licenseNo",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "营业执照编号",
            labelCol: { span: 6 },
            fieldName: "licenseNo",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "邮箱",
            labelCol: { span: 6 },
            fieldName: "mailbox",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "邮编",
            labelCol: { span: 6 },
            fieldName: "postcode",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "传真",
            labelCol: { span: 6 },
            fieldName: "faxes",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "备注",
            labelCol: { span: 6 },
            fieldName: "note",
        },{
            type: FormItemTypeEnum.Switch,
            span: 8,
            fieldLabel: "状态",
            labelCol: { span: 6 },
            fieldName: "enable",
            valuePropName: "checked",
            checkedChildren: "启用",
            unCheckedChildren: "禁用"
        },
        //带出
        // {
        //     type: FormItemTypeEnum.Input,
        //     span: 8,
        //     fieldLabel: "应用名称",
        //     labelCol: { span: 6 },
        //     fieldName: "applicationName",
        //     hidden: true
        // },

    ]
    const title = <div className="font-bold font-size-lg">{setTitle(mode)}经营实体</div>
    const reset = () => {
        form.resetFields()
        if (mode == DetailType.add) {
            setAddParam({})
        } else if (mode == DetailType.edit) {
            form.setFieldsValue({ code: selectedRow[0].code })
            setSelectedRow([{ code: selectedRow[0].code }])
        }
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode == DetailType.look}
            onClick={() => form.submit()}
        >保存</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode == DetailType.look}
            onClick={() => reset()}
        >重置</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => close()}
        >取消</Button>
    </>
    return <Form
        form={form}
        onValuesChange={mode == DetailType.add ? updataAddParam : updataEditParam}
        onFinish={onFinish}
    >
        <YhFormItemsBox disabled={mode == DetailType.look} items={items} title={title} action={action} IclassName="p-20" />
    </Form>
}
export default EntityDetail